export function isEditedHSQC(experiment) {
    // detection whether experiment is an edited HSQC
    return experiment.info.pulseSequence.includes('hsqced');
}
//# sourceMappingURL=isEditedHSQC.js.map